import React from "react";
import * as S from "./Alert.styles";
import { AlertComponentPropsWithStyle } from "react-alert";
import { StyleProp, ViewStyle } from "react-native";

class Alert extends React.PureComponent<AlertComponentPropsWithStyle> {
  // Lifecycle methods
  public render = () => {
    const { style, options, message, close } = this.props;
    return (
      <S.Wrap
        style={style as StyleProp<ViewStyle>}
        type={options.type}
        onPress={close}
      >
        <S.CloseButton onPress={close}>
          {/*
          // @ts-ignore */}
          <S.CloseButtonImage type={options.type} />
        </S.CloseButton>
        <S.Message type={options.type}>{message}</S.Message>
      </S.Wrap>
    );
  };
}

export default Alert;
